/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Report_Invite_TitleInputs */



/**
* | output |
* | --- |
* | "No report yet" |
*
* @param {Meeting_Report_Invite_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_report_invite_title = /** @type {((inputs?: Meeting_Report_Invite_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Report_Invite_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Nog geen verslag")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas encore de compte rendu")
	return /** @type {LocalizedString} */ ("No report yet")
});